<template>
  <div class="invoice-info-container">
    <h3>开票信息</h3>
    
    <div class="form-container">
      <!-- 是否开发票 -->
      <div class="form-item">
        <label style="display: flex;">
          <span class="item-title">是否开发票：</span>
          <el-radio-group v-model="vat_invoice_open_type">
            <el-radio :label="1">开票</el-radio>
            <el-radio :label="2">不开票</el-radio>
          </el-radio-group>
        </label>
      </div>

      <!-- 开票类型 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1">
        <label style="display: flex;">
          <span class="item-title">开票类型：</span>
          <el-radio-group v-model="vat_invoice_type">
            <el-radio :label="1">普通发票</el-radio>
            <el-radio :label="2">专用发票</el-radio>
          </el-radio-group>
        </label>
      </div>

      <!-- 发票抬头 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 1">
        <label style="display: flex;">
          <span class="item-title">发票抬头：</span>
          <el-radio-group v-model="vat_invoice_title">
            <el-radio :label="1">企业</el-radio>
            <el-radio :label="2">个人</el-radio>
          </el-radio-group>
        </label>
      </div>

      <!-- 个人名称 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 1 && vat_invoice_title == 2">
        <label>
          <span class="item-title">个人名称：</span>
          <el-input v-model.trim="individual_title_name" placeholder="请输入个人名称"></el-input>
        </label>
      </div>

      <!-- 纳税人名称 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1 && (vat_invoice_type == 2 || (vat_invoice_type == 1 && vat_invoice_title == 1))">
        <label>
          <span class="item-title">纳税人名称：</span>
          <el-input v-model.trim="tax_name" placeholder="请输入纳税人名称"></el-input>
        </label>
      </div>

      <!-- 税务登记号 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1 && (vat_invoice_type == 2 || (vat_invoice_type == 1 && vat_invoice_title == 1))">
        <label>
          <span class="item-title">税务登记号：</span>
          <el-input v-model.trim="tax_no" placeholder="请输入税务登记号"></el-input>
        </label>
      </div>

      <!-- 专用发票额外字段 -->
      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 2">
        <label>
          <span class="item-title">税务登记地址：</span>
          <el-input v-model.trim="tax_address" placeholder="请输入税务登记地址"></el-input>
        </label>
      </div>

      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 2">
        <label>
          <span class="item-title">税务登记联系电话：</span>
          <el-input v-model.trim="tax_mobile" placeholder="请输入税务登记联系电话"></el-input>
        </label>
      </div>

      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 2">
        <label>
          <span class="item-title">税务开户银行名称：</span>
          <el-input v-model.trim="tax_bank" placeholder="请输入税务开户银行名称"></el-input>
        </label>
      </div>

      <div class="form-item" v-if="vat_invoice_open_type == 1 && vat_invoice_type == 2">
        <label>
          <span class="item-title">税务开户银行账号：</span>
          <el-input v-model.trim="tax_bank_no" placeholder="请输入税务开户银行账号"></el-input>
        </label>
      </div>
    </div>

    <!-- 操作按钮 -->
    <div class="button-container">
      <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getPingAnTrunkPolicyInfo, updatePingAnTrunkPolicy } from '@/api/gxborder'

export default {
  name: 'PingAnTrunkInvoiceInfo',
  props: {
    policyId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      saving: false,
      // 开票相关字段
      vat_invoice_open_type: 2,      // 发票状态，默认不开票
      vat_invoice_type: 1,           // 开票类型  1 普通 2 专用
      vat_invoice_title: 1,          // 发票抬头  1 企业 2 个人
      individual_title_name: '',     // 发票抬头个人名称
      tax_name: "",                  // 纳税人名称
      tax_no: "",                    // 税务登记号
      tax_address: "",               // 税务登记地址
      tax_mobile: "",                // 税务登记联系电话
      tax_bank: "",                  // 税务开户银行名称
      tax_bank_no: "",               // 税务开户银行账号
    }
  },
  created() {
    this.getInfo()
  },
  methods: {
    // 获取保单信息
    async getInfo() {
      try {
        const response = await getPingAnTrunkPolicyInfo({ id: this.policyId })
        if (response.err_code === 0) {
          const data = response.data
          // 设置开票信息
          this.vat_invoice_open_type = data.vat_invoice_open || 2
          this.vat_invoice_type = data.vat_invoice_type || 1
          this.vat_invoice_title = data.vat_invoice_title || 1
          this.individual_title_name = data.individual_title_name || ''
          this.tax_name = data.tax_name || ''
          this.tax_no = data.tax_no || ''
          this.tax_address = data.tax_address || ''
          this.tax_mobile = data.tax_mobile || ''
          this.tax_bank = data.tax_bank || ''
          this.tax_bank_no = data.tax_bank_no || ''
        } else {
          this.$message.error(response.err_msg || '获取保单信息失败')
        }
      } catch (error) {
        console.error('获取保单信息失败:', error)
        this.$message.error('获取保单信息失败')
      }
    },

    // 保存开票信息
    async save() {
      this.saving = true
      try {
        // 收集数据
        const data = {
          id: this.policyId,
          vat_invoice_open: this.vat_invoice_open_type
        }

        if (this.vat_invoice_open_type == 1) {
          data.vat_invoice_type = this.vat_invoice_type
          if (this.vat_invoice_type == 1) {
            data.vat_invoice_title = this.vat_invoice_title
            if (this.vat_invoice_title == 1) {  // 企业
              data.tax_name = this.tax_name
              data.tax_no = this.tax_no
            } else if (this.vat_invoice_title == 2) { // 个人
              data.individual_title_name = this.individual_title_name
            }
          } else if (this.vat_invoice_type == 2) {
            data.tax_name = this.tax_name
            data.tax_no = this.tax_no
            data.tax_address = this.tax_address
            data.tax_mobile = this.tax_mobile
            data.tax_bank = this.tax_bank
            data.tax_bank_no = this.tax_bank_no
          }
        }

        const response = await updatePingAnTrunkPolicy(data)
        if (response.err_code === 0) {
          this.$message.success('保存成功')
          this.cancel()
        } else {
          this.$message.error(response.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    // 取消
    cancel() {
      // 通知父组件关闭对话框
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.invoice-info-container {
  padding: 20px;
  max-width: 600px;
  margin: 0 auto;
}

h3 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.form-container {
  margin-bottom: 30px;
}

.form-item {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.item-title {
  display: inline-block;
  width: 150px;
  text-align: right;
  margin-right: 10px;
  font-weight: 500;
}

.el-input {
  width: 200px;
}

.el-radio-group {
  display: flex;
  gap: 10px;
}

.button-container {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.button-container .el-button {
  margin: 0 10px;
  min-width: 80px;
}
</style>